import React from "react";
import { Modal } from "@mui/material";
import moment from "moment";

import afterLoginApiAxios from "../../Util/API Calls/afterLogin";

import CheckIcon from "../../assets/check.png";
import "./component-styles.scss";
import { useState } from "react";

export default function MarkCheckInSuccessModal({
  openView,
  closeView,
  appointmentDetails,
  refreshAppointmentsMethod,
  invoiceUrl,
  completionTime,
  printInvoice,
  dashboardRaiseInvoiceSuccessModal,
}) {
  // const printInvoice = () => {
  //   return (
  //     "<html><head><scri" +
  //     "pt>function step1(){\n" +
  //     "setTimeout('step2()', 10);}\n" +
  //     "function step2(){window.print();window.close()}\n" +
  //     "</scri" +
  //     "pt></head><body onload='step1()'>\n" +
  //     "<iframe src='" +
  //     invoiceUrl +
  //     "' scrolling='yes' style='width:1000px; height:2000px !important;'/></body></html>"
  //   );
  // };

  // const printReceipt = () => {
  //   var invoiceUrl = invoiceUrl;
  //   var pwa = window.open(invoiceUrl, "_new");
  //   pwa.document.open();
  //   closeView();
  //   pwa.document.write(printInvoice());
  //   pwa.document.close();
  //   window.location.reload()
  // };

  return (
    <>
      {openView ? (
        <Modal
          open={openView}
          onClose={closeView}
          centered={true}
          dialogClassName="mark-check-succss"
          className="modal-check-in"
        >
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className="invoice-raised-success-modal-wrapper p-3 p-lg-5">
            <div className="d-flex flex-column justify-content-center align-items-center modal_action_heading">
              <img src={CheckIcon} alt="success" />
              <h4 className="mt-3 text-center">
                {dashboardRaiseInvoiceSuccessModal
                  ? "Invoice Raised Successfully"
                  : "Marked Check In Successfully"}
              </h4>
              <p className="text-center my-2">
                Your In-Clinic consultation with
                <br />
                <span>
                  <b>{`Patient: ${appointmentDetails?.patient_name} `}</b>
                  scheduled on
                  <b>
                    {appointmentDetails?.appointment_date != "" &&
                      appointmentDetails?.appointment_start_time != "" &&
                      ` ${moment(
                        new Date(
                          appointmentDetails?.appointment_date +
                            " " +
                            appointmentDetails?.appointment_start_time
                        )
                      ).format("MMM DD, YYYY, hh:mm A")}.`}
                  </b>
                </span>
                <br />
                has been marked completed on
                <b>
                  {appointmentDetails?.appointment_date != "" &&
                    completionTime != "" &&
                    ` ${moment
                      .utc(completionTime)
                      .local()
                      .format("MMM DD, YYYY, hh:mm A")}.`}
                </b>
              </p>
              <div className="d-flex flex-row justify-content-center my-3 modal_action_button">
                <button
                  className="btn primary-cta-button rounded-pill px-4 first_button"
                  onClick={closeView}
                >
                  Okay
                </button>
                <button
                  className={`btn secondary-button rounded-pill secon_button ${
                    invoiceUrl === "" ? "btn_disabled" : ""
                  }`}
                  onClick={() => printInvoice()}
                  disabled={invoiceUrl === "" ? true : false}
                >
                  Print Receipt
                </button>
              </div>
            </div>
          </div>
        </div>
        </Modal>
      ) : null}
    </>
  );
}
